import styled from "styled-components";

export const InsuranceSumFeedback = styled.p`
  background-color: ${({ theme }) =>
    theme.table ? theme.table.backgroundColor : theme.brandColors.surface.main};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  margin-bottom: ${({ theme }) => theme.spacing.md};
  padding: 1rem;
`;
